import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import MobileSidebar from './MobileSidebar';
import InterfaceLanguageSelect from './InterfaceLanguageSelect';
import { useActiveChatDomain } from '../ActiveChatDomainContext';

export default function Header({ onLogout }) {
  const { t } = useTranslation('workspace');
  const { domain } = useActiveChatDomain();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const mobile = window.matchMedia?.('(max-width: 768px)');
    if (!mobile) return;
    const closeOnDesktop = () => { if (!mobile.matches) setOpen(false); };
    mobile.addEventListener('change', closeOnDesktop);
    return () => mobile.removeEventListener('change', closeOnDesktop);
  }, []);
  return <>
    <header className="ws-header">
      <button className="ws-icon-button ws-mobile-menu-trigger" type="button" onClick={() => setOpen(true)} aria-label={t('menu')} aria-haspopup="dialog"><FiMenu /></button>
      <Link className="ws-brand" to="/chat"><img src="/Logo.png" alt="" /><span>UpyaChat</span></Link>
      <InterfaceLanguageSelect compact />
    </header>
    <MobileSidebar isOpen={open} onClose={() => setOpen(false)} onLogout={onLogout} activeDomain={domain} />
  </>;
}
